export const FLOAT64_PRECISION = 53;
export const FLOAT64_EMIN = -1022;
export const FLOAT64_EMAX = 1023;
export const FLOAT64_MIN = 2.2250738585072014e-308;
const _FLOAT64_MIN_2 = 2 * FLOAT64_MIN;
export const FLOAT64_MAX = 1.7976931348623157e+308;
export const FLOAT64_EPS = 2.220446049250313e-16;
const ϕ = Math.pow(2, 52) + 1;
const _1p = 1 + Number.EPSILON;
const _1m = 1 - Number.EPSILON / 2;
const ufp_xmax = FLOAT64_MAX / ϕ;
const epsx_overflow = Math.pow(2, 971);
export function eps(x = 1) {
    if (Number.isFinite(x)) {
        x = Math.abs(x);
        if (x < _FLOAT64_MIN_2) {
            return Number.MIN_VALUE;
        }
        const q = _1p * x;
        return q - _1m * q || epsx_overflow;
    }
    return NaN;
}
export const ulp = eps;
export function ufp(x) {
    if (Number.isFinite(x) && x !== 0) {
        x = Math.abs(x);
        return x <= ufp_xmax ? _ufp(x) : Math.pow(2, _exponent_s(x));
    }
    return x === 0 ? 0 : NaN;
}
function _ufp(x) {
    const q = ϕ * x;
    return q - _1m * q;
}
export function exponent(x) {
    if (Number.isFinite(x) && x !== 0) {
        x = Math.abs(x);
        return x <= ufp_xmax ? _exponent_u(x) : _exponent_s(x);
    }
    return NaN;
}
function _exponent_u(x) {
    return (x | 0) === x ? 31 - Math.clz32(x) : Math.log2(_ufp(x));
}
function _exponent_s(x) {
    const s = x.toString(2);
    return x < 1 ? -(s.split('1', 1)[0].length - 1) : s.split('.', 1)[0].length - 1;
}
export function nextFloat(x) {
    switch (x) {
        case -Infinity:
            return -Number.MAX_VALUE;
        case Infinity:
        case Number.MAX_VALUE:
            return Infinity;
        case -Number.MIN_VALUE:
            return -0;
        default:
            if (!Number.isFinite(x)) {
                return NaN;
            }
    }
    const e = eps(x);
    const y = x + e / 2;
    return y > x ? y : x + e;
}
export function prevFloat(x) {
    return typeof x === 'number' ? -nextFloat(-x) : NaN;
}
